import PropTypes from 'prop-types';
// form
import {Controller, useFormContext} from 'react-hook-form';
// @mui
import {Autocomplete} from '@mui/material';

// ----------------------------------------------------------------------

RHFAutocomplete.propTypes = {
    name: PropTypes.string,
};

export default function RHFAutocomplete({name, icon, ...other}) {
    const {control} = useFormContext();

    return <Controller
        name={name}
        control={control}
        render={({field, fieldState: {error}}) =>
            <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="Unesite bar jedan karakter..."
                fullWidth size="small"
                          {...field}
                          {...other} />}/>;
}
